import {React,Fragment,useState} from "react";
import './KindleDetail.scss';
import '@fortawesome/react-fontawesome';




import linkIcon from "../../../assets/icons/cardLink.svg";



import "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import axios from "axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";


import "@fortawesome/free-solid-svg-icons";
import '@headlessui/react';
function KindleSingleDetail() {
const [isLoading, setIsLoading] = useState(false);
const [kindleCreated, ] = useState(false);
const [kindle, setKindleDetail] = useState([]);
const kindleId = useParams();
const [uniqueColors, setUniqueColors] = useState('');
useState('Location');
useState('Location');



useEffect(() => {
    // Refetch for this route/refresh only; discard the previous request on cleanup.
    const controller = new AbortController();
    let active = true;

   // Function to fetch data from the API and update the state
   const token = localStorage.getItem("token");

   const fetchHighlights = async () => {
    setIsLoading(true);
     try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}books/highlight-detail/${kindleId.id}`,
        {}, // Empty object for POST body if no specific data needs to be sent
        { signal: controller.signal,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json', // Recommended to specify content type
          },
        }
      );
        if (!active) return;
       setIsLoading(false);
       // setKindle(response?.data?.data); // Assuming the API response is an array of bucket objects
       setKindleDetail(response?.data?.data);
       const colors = response?.data?.data?.color;
      //  const uniqueColors = [...new Set(colors)];
       // Set the unique colors in state
       setUniqueColors(typeof colors === 'string' ? colors : '');
     } catch (error) {
        if (!active) return;
        setIsLoading(false);
       console.error("Error fetching data:", error);
     }
   };
   if (token) {
      fetchHighlights();
   }

    return () => { active = false; controller.abort(); };
  }, [kindleCreated, kindleId.id]);



return(
    <>
    {isLoading ? (
        <div className="App-loading">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : (
      <>
      <div className="kindle-detail kindle-detail-desktop">
          <div className="flex justify-between mb-3">
            <div className="flex items-center justify-end">
              <a href="/app/kindleList"><span className="project-nav">Kindle</span></a>&nbsp;<span className="project-nav">/</span>&nbsp;<a href={`/app/kindledetail/${kindle?.bookId?._id}`} className="breadcrumbs-title"><span className="project-nav">{kindle?.bookId?.title}</span></a>
            </div>
          </div>
      <hr className="mt-[20px] mb-[30px]" />
      <div className="row w-3/3 flex "> 
          <div>
              <div className="kindle-card">
                  <h5><a href={`/app/kindledetail/${kindle?.bookId?._id}`}>{kindle?.bookId?.title}</a></h5>
                  <h6>{kindle?.bookId?.authorName}</h6>
                  <div className="flex">
                  {/* <div className="mt-auto">
                  <span>Highlights</span>
                  </div> */}
                  {/* <div className="ml-auto">
                  <img src={amazonkindle} alt="Kindleimage"/>
                  </div> */}
                  </div>
                  <a href={`/app/kindledetail/${kindle?.bookId?._id}`}>
                    <img className="my-[5px] kindle-image" src={kindle?.bookId?.image} alt="Kindleimage"/>
                  </a>
                  <p style={{fontSize:"14px",marginTop:"12px",marginBottom:"6px"}}>Last accessed on {moment(kindle?.bookId?.lastHighlightDate).format(
                          "MMM D, YYYY"
                        )} </p>
                  <div className="w-full">

                          <div className={`kindle-box bg-green w-[100%]"}`} style={{backgroundColor:uniqueColors.toLowerCase() === 'yellow' ? '#F2E366' : uniqueColors, marginLeft: 0}}>
                              {/* <img className="kindle-tick" src={Tick} alt="Tick" /> */}
                          </div>

                      {/* <div className="kindle-box ml-[2px] bg-afc604 w-[50%]">
                          <img className="kindle-tick" src={Tick} alt="Tick" />

                          </div> */}
                  </div>
              </div>
          </div>
          <div className="w-3/3 ml-[24px]">

                  <div className="kindlecard" style={{borderTop:`14px solid ${kindle?.color?.toLowerCase() === 'yellow' ? '#F2E366' : kindle?.color}`}}>
                  <div className="menu-kindle">
                      <div className="flex actionsHolder items-center">
                      <p className="last-updated flex"> Location {kindle?.location}</p>
                          {/* <div>
                              <a href="#" className="flex items-center">
                              <FontAwesomeIcon className="transform rotate-45" icon={faArrowUp } />
                              <span className="actionicon-content pl-3">Move to</span>
                              </a>
                          </div> */}
                          {/* <div>
                              <a href="#" className="flex items-center pl-[14px]">
                              <img className="w-6 trash-icon" src={trashIcon} alt="trashIcon"/>
                              <span className="actionicon-content pl-3">Delete</span>
                              </a>
                          </div> */}
                          {/* <div>
                              <a href="#" className="flex items-center pl-[14px]">
                              <img className="w-6" src={filledIcon} alt="copy-to" />
                              <span className="actionicon-content pl-3">Copy to</span>
                              </a>
                          </div>
                          <div>
                              <a href="#" className="flex items-center pl-[14px]">
                              <img className="w-5" src={sourceLink} alt="source-link" />
                              <span className="actionicon-content pl-3">Open in Kindle</span>
                              </a>
                          </div> */}
                      </div>
                      <div className="sharedAction flex items-center">
                          {/* <div className="bg-[#FFE6D6] flex items-center px-3 py-1 rounded-2xl  mr-[10px]">
                              <p className="publicytext-content">Publicly Shared</p>
                              <span className="bg-white rounded-[50%] p-1 ml-2">
                              <img src={copyIcon} alt="copy-icon" />
                              </span>
                          </div> */}
                          <div className="w-6 mx-2">
                              <img className="cardicon-imgcontent menu-icon" src={linkIcon} alt="link-icon" />
                          </div>
                          {/* <div className="w-7 mx-2">
                              <img className="cardicon-imgcontent menu-icon" src={shareIcon} alt="shareIcon" />
                          </div> */}
                      </div>
                  </div>
                  <div className="mt-[10px]">
                      <p className="kindle-content">{kindle?.text}</p>
                  </div>
                  </div>
          </div>
      </div>
      </div>
      <div className="kindle-detail kindle-detail-mobile">

          {/* <div className="ml-auto">
                  <div className="ml-[auto] flex items-center justify-end">
                    <span className="sorttext-content mx-3 dark:text-[#acacac]">Sort By</span>
                    <Menu as="div" className="relative flex-shrink-0">
                      <div>
                        <Menu.Button className="flex rounded-full focus:outline-none ">
                          <div href="#" className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500">
                            <strong className="createdtext-content pr-4">{cardLabelDefault}</strong>
                            <FontAwesomeIcon style={{fontSize:'12px',color:'#707070'}} icon={faChevronDown} />
                          </div>
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">                           
                          {filterDropDown.map((item) => (
                            <Menu.Item key={item.name}>
                              {({ active }) => (
                                <a
                                  onClick={()=>{handleFilterText(item.name)}}
                                  href={item.href}
                                  className={classNames(
                                    active ? 'bg-gray-100' : '',
                                    'block py-2 px-4 text-[13px] text-gray-700'
                                  )}
                                >

                                  {cardLabelDefault == item.name ? item.name : item.name}
                                </a>
                              )}
                            </Menu.Item>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div> 
                </div>    */}
                <div className="flex justify-between mb-3">
                  <div className="flex items-center justify-end">
                    <a href="/app/kindleList"><span className="project-nav">Kindle</span></a>&nbsp;<span className="project-nav">/</span>&nbsp;<a href={`/app/kindledetail/${kindle?.bookId?._id}`} className="breadcrumbs-title"><span className="project-nav">{kindle?.bookId?.title}</span></a>
                  </div>
                </div>
      <hr className="mt-[20px] mb-[30px]" />
      <div>
                    <div className="kindle-card">
                        <h5><a href={`/app/kindledetail/${kindle?.bookId?._id}`}>{kindle?.bookId?.title}</a></h5>
                        <h6>{kindle?.bookId?.authorName}</h6>
                        <div className="flex">
                        {/* <div className="mt-auto">
                        <span>Highlights</span>
                        </div> */}
                        {/* <div className="ml-auto">
                        <img src={amazonkindle} alt="Kindleimage"/>
                        </div> */}
                        </div>
                        <a href={`/app/kindledetail/${kindle?.bookId?._id}`}>
                          <img className="my-[5px] kindle-image" src={kindle?.bookId?.image} alt="Kindleimage"/>
                        </a>
                        <p style={{fontSize:"14px",marginTop:"12px",marginBottom:"6px"}}>Last accessed on {moment(kindle?.bookId?.lastHighlightDate).format(
                                "MMM D, YYYY"
                              )} </p>
                        <div className="w-8">
                                <div className={`kindle-box bg-green w-[100%]`} style={{backgroundColor:uniqueColors?.toLowerCase() === 'yellow' ? '#F2E366' : uniqueColors, marginLeft: 0}}>
                                    {/* <img className="kindle-tick" src={Tick} alt="Tick" /> */}
                                </div>

                            {/* <div className="kindle-box ml-[2px] bg-afc604 w-[50%]">
                                <img className="kindle-tick" src={Tick} alt="Tick" />

                                </div> */}
                        </div>
                    </div>
                </div>
      <div className="row w-3/3 flex mt-5"> 
          <div className="w-3/3">
                  <div className="kindlecard" style={{borderTop:`14px solid ${kindle?.color?.toLowerCase() === 'yellow' ? '#F2E366' : kindle?.color}`}}>
                  <div className="menu-kindle">
                      <div className="flex actionsHolder items-center">
                      <p className="last-updated flex"> Location {kindle?.location}</p>
                          {/* <div>
                              <a href="#" className="flex items-center">
                              <FontAwesomeIcon className="transform rotate-45" icon={faArrowUp } />
                              <span className="actionicon-content pl-3">Move to</span>
                              </a>
                          </div> */}
                          {/* <div>
                              <a href="#" className="flex items-center pl-[14px]">
                              <img className="w-6 trash-icon" src={trashIcon} alt="trashIcon"/>
                              <span className="actionicon-content pl-3">Delete</span>
                              </a>
                          </div> */}
                          {/* <div>
                              <a href="#" className="flex items-center pl-[14px]">
                              <img className="w-6" src={filledIcon} alt="copy-to" />
                              <span className="actionicon-content pl-3">Copy to</span>
                              </a>
                          </div>
                          <div>
                              <a href="#" className="flex items-center pl-[14px]">
                              <img className="w-5" src={sourceLink} alt="source-link" />
                              <span className="actionicon-content pl-3">Open in Kindle</span>
                              </a>
                          </div> */}
                      </div>
                      <div className="sharedAction flex items-center">
                          {/* <div className="bg-[#FFE6D6] flex items-center px-3 py-1 rounded-2xl  mr-[10px]">
                              <p className="publicytext-content">Publicly Shared</p>
                              <span className="bg-white rounded-[50%] p-1 ml-2">
                              <img src={copyIcon} alt="copy-icon" />
                              </span>
                          </div> */}
                          <div className="w-6 mx-2">
                              <img className="cardicon-imgcontent menu-icon" src={linkIcon} alt="link-icon" />
                          </div>
                          {/* <div className="w-7 mx-2">
                              <img className="cardicon-imgcontent menu-icon" src={shareIcon} alt="shareIcon" />
                          </div> */}
                      </div>
                  </div>
                  <div className="mt-[10px]">
                      <p className="kindle-content">{kindle?.text}</p>
                  </div>
                  </div>
          </div>
      </div>
      </div>
      </>
    )}
    </>
);
}
export default KindleSingleDetail;